import React from 'react';

/* @Components */
import { FooterComponent } from './FooterComponent';

export const FooterContainer = () => {
  return <FooterComponent />;
};
